"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var AppLogo = styled_components_1.default.img(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  height: auto;\n  cursor: pointer;\n  ", "\n"], ["\n  width: 100%;\n  height: auto;\n  cursor: pointer;\n  ", "\n"])), function (_a) {
    var size = _a.size;
    return (size === 'xs' ? "max-width: 10em;" : "max-width: 15em;");
});
exports.default = AppLogo;
var templateObject_1;
//# sourceMappingURL=AppLogo.js.map